import React from 'react'
import { createGlobalStyle } from 'styled-components'
import '@devicebits/component-library/dist/index.css'
import { OptionsHOC } from '../../hocs'

const GlobalStyleInject = ({ getOption }) => {
  const fontName = getOption('fontFamily.url')
  const fontUrl = getOption('fontFamily.url')
  let accentColor = getOption('theme.accentColor') || getOption('specs.tryButtonBackground')
  const mainColor = getOption('theme.mainColor') || getOption('moreHelpFooter.buttonColor')
  const botColor = getOption('theme.botColor')
  const textOnButtons =
    getOption('theme.buttons.textOnButtons') ||
    getOption('specs.tryButtonFont') ||
    'white'
  const navigationText =
    getOption('theme.navigationText') ||
    getOption('specs.tryButtonFont') ||
    'white'
  const headerBackgroundColor =
    getOption('theme.headerBackgroundColor') ||
    getOption('header.backgroundColor')
  let darkModeAccentColor =
    getOption('theme.dark.accentColor') ||
    getOption('theme.accentColor') ||
    getOption('specs.tryButtonBackground')
  const footerColor =
    getOption('theme.footerColor') || getOption('footer.backgroundColor')
  const searchButtonBackground = getOption('theme.searchButtonBackground')
  const darkModeFooterColor = getOption('theme.dark.footerColor')
  if (['#fff', '#ffffff'].includes(accentColor.toLowerCase())) {
    accentColor = '#8d8d8d'
  }
  if (['#fff', '#ffffff'].includes(darkModeAccentColor.toLowerCase())) {
    darkModeAccentColor = '#8d8d8d'
  }
  const homeText = getOption('theme.homeTextColor')
  const borderRadius = getOption('theme.buttons.buttonBorderRadius') || '4px'
  const btnColor = getOption('theme.buttons.buttonColor')
  const footerHeight = getOption('footer.height')

  const GlobalStyle = createGlobalStyle`

@font-face {
    font-family: 'Verizon-NHG-eTX';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('https://scache1.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeTX-Regular.eot?#iefix')
        format('embedded-opentype'),
      url('https://scache1.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeTX-Regular.woff2')
        format('woff2'),
      url('https://scache1.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeTX-Regular.woff')
        format('woff'),
      url('https://scache1.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeTX-Regular.ttf')
        format('truetype');
  }
  @font-face {
    font-family: 'Verizon-NHG-eTX';
    font-weight: 700;
    font-display: swap;
    src: url('https://scache2.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeTX-Bold.eot?#iefix')
        format('embedded-opentype'),
      url('https://scache2.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeTX-Bold.woff2')
        format('woff2'),
      url('https://scache2.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeTX-Bold.woff')
        format('woff'),
      url('https://scache2.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeTX-Bold.ttf')
        format('truetype');
  }
  @font-face {
    font-family: 'Verizon-NHG-eDS';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: url('https://scache1.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeDS-Regular.eot?#iefix')
        format('embedded-opentype'),
      url('https://scache1.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeDS-Regular.woff2')
        format('woff2'),
      url('https://scache1.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeDS-Regular.woff')
        format('woff'),
      url('https://scache1.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeDS-Regular.ttf')
        format('truetype');
  }
  @font-face {
    font-family: 'Verizon-NHG-eDS';
    font-weight: 700;
    font-display: swap;
    src: url('https://scache2.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeDS-Bold.eot?#iefix')
        format('embedded-opentype'),
      url('https://scache2.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeDS-Bold.woff2')
        format('woff2'),
      url('https://scache2.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeDS-Bold.woff')
        format('woff'),
      url('https://scache2.vzw.com/globalnav/fonts/verizon-nhg/VerizonNHGeDS-Bold.ttf')
        format('truetype');
  }

  body {
    --headingFont: ${fontName};
    --bodyFont: ${fontName};
    --clr-accent: ${accentColor} !important;
    --clr-main: ${mainColor} !important;
    --clr-bot-main: ${botColor} !important;
    --clr-text-on-button: ${textOnButtons} !important;
    --clr-nav-text: ${navigationText} !important;
    --clr-custom-to-accent: ${headerBackgroundColor} !important;
    --clr-footer-bg: ${footerColor} !important;
    --home-text: ${homeText} !important;
    --button-border-radius: ${borderRadius} !important;
    --clr-set-btn: ${btnColor} !important;
    --search-button-bg: ${searchButtonBackground};
    --footer-height: ${footerHeight};
  }

  .dark {
    --clr-accent: ${darkModeAccentColor} !important;
    --clr-white-to-accent: ${darkModeAccentColor} !important;
    --clr-nav-text-to-accent: ${darkModeAccentColor} !important;
    --clr-grey-3-to-accent: ${darkModeAccentColor} !important;
    --clr-custom-to-accent: ${darkModeAccentColor} !important;
    --clr-footer-bg: ${darkModeFooterColor} !important;
  }
`
  return <GlobalStyle />
}

export default OptionsHOC(GlobalStyleInject)



// WEBPACK FOOTER //
// ./src/components/GlobalStyleInject/index.js